const htmlTag = document.querySelector('html'); // this isn't the body class :facepalm: -> document.documentElement

const toggleBodyClass = (bodyClass) => {
  if (typeof bodyClass !== 'string') throw Error('Given argument is not a string');

  htmlTag.classList.toggle(bodyClass);
};

export default toggleBodyClass;
